// A local preview linking to the live site is still a test visit.
export function isLocalTrafficSource(value) {
  if (!value) return false;
  let host;
  try { host = new URL(String(value).includes('://') ? value : `http://${value}`).hostname.toLowerCase().replace(/^\[|\]$/g, ''); }
  catch { return false; }
  if (/^(localhost|0\.0\.0\.0|::1)$/.test(host) || /\.(localhost|local|test|internal|invalid)$/.test(host)) return true;
  if (/^(fc|fd)[\da-f]{2}:|^fe[89ab][\da-f]:/i.test(host)) return true;
  const octets = host.split('.').map(Number);
  return octets.length === 4 && octets.every(n => Number.isInteger(n) && n >= 0 && n <= 255)
    && (octets[0] === 127 || octets[0] === 10 || (octets[0] === 192 && octets[1] === 168)
      || (octets[0] === 172 && octets[1] >= 16 && octets[1] <= 31) || (octets[0] === 169 && octets[1] === 254));
}
